// AdminLTE 4 JS entrypoint

// ── jQuery をグローバルに公開（jquery-ui などの jQuery plugin より先に必須）──
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
globalThis.$ = $;
globalThis.jQuery = $;

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import 'admin-lte/dist/js/adminlte.js';

// AngularJS legacy modules (previously provided by admin.bundle)
const angular = require('angular');
globalThis.angular = angular;
if (typeof window !== 'undefined') {
  window.angular = angular;
}
require('angular-local-storage');
require('angular-ui-grid/ui-grid.min.js');
require('jsbarcode');

const JSONEditorModule = require('@json-editor/json-editor');
const JSONEditor = JSONEditorModule.JSONEditor;

// Node.js環境とブラウザ環境の両方に対応
if (typeof global !== 'undefined') {
    global.JSONEditor = JSONEditor;
}
if (typeof window !== 'undefined') {
    window.JSONEditor = JSONEditor;
}

// ── Quill ─────────────────────────────────────────────
import Quill from 'quill';

// ── Chart.js ──────────────────────────────────────────
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

// ── ApexCharts ────────────────────────────────────────
import ApexCharts from 'apexcharts';

// ── SortableJS ────────────────────────────────────────
import Sortable from 'sortablejs';

// ── OverlayScrollbars ─────────────────────────────────
import { OverlayScrollbars } from 'overlayscrollbars';

// ── Select2 (jQuery plugin — needs window.$ before import) ──
//   select2 は既存ページの jQuery インスタンスに対してプラグインを追加する
//   バンドル側で jQuery をグローバルにせずに import すると $.fn.select2 が
//   既存ページの jQuery に登録されないため、CDN/assets の jQuery を使う
//   → select2 の dist ファイルをコピーして個別読み込み方式とする

// ── Ace (noconflict bundle — loaded via <script> copy) ─
//   ace-builds は src-min-noconflict/ を個別ファイルとしてコピーするため
//   webpack バンドルには含めず、グローバル ace は copy-backoffice-assets で提供
require('jquery-ui/dist/themes/base/jquery-ui.min.css');
require('jquery-ui/dist/jquery-ui');

// ── Globals ───────────────────────────────────────────
globalThis.$              = $;
globalThis.jQuery         = $;
globalThis.bootstrap        = bootstrap;
globalThis.Quill             = Quill;
globalThis.Chart             = Chart;
globalThis.ApexCharts        = ApexCharts;
globalThis.Sortable          = Sortable;
globalThis.OverlayScrollbars = OverlayScrollbars;
globalThis.angular           = angular;

console.log('adminLTE 4 JS bundle is loaded');
